import { mpEventInfo } from '@/constant'
import type { DefaultResponse, Pagination } from '@/types'
import maxios from '@/utils/axios/maxios'

// 반 API
const lessonClassApi = {
  // 반 정보 가져오기
  getLessonClass(pageQueryString: string) {
    return maxios.get<Pagination<res.LessonClass[]>>(`/lesson-classes${pageQueryString}`, {
      params: { mp_event_name: mpEventInfo.반조회 },
    })
  },
  // 반 생성하기
  postLessonClass(data: req.LessonClassDetail) {
    return maxios.post('/lesson-classes', data, {
      params: { mp_event_name: mpEventInfo.반생성 },
    })
  },
  // 특정 반 정보 변경하기
  patchLessonClass(id: req.LessonClassId, data: req.LessonClassDetail) {
    return maxios.patch(`/lesson-classes/${id}`, data, {
      params: { mp_event_name: mpEventInfo.반정보수정 },
    })
  },
  // 반 순서 변경하기
  putLessonClassesOrder(data: req.LessonClassOrder) {
    return maxios.put('/lesson-classes/order', data, {
      params: { mp_event_name: mpEventInfo.반순서수정 },
    })
  },
  // 반 삭제하기
  deleteLessonClasses(data: req.LessonClassId[]) {
    return maxios({
      url: '/lesson-classes',
      method: 'DELETE',
      data,
      params: { mp_event_name: mpEventInfo.반삭제 },
    })
  },
  // 배정된 반이 있는 선생님 가져오기
  getClassAssignedTeachers() {
    return maxios.get<DefaultResponse<res.ClassAssignedTeacher[]>>('/lesson-classes/teacher', {
      params: { mp_event_name: mpEventInfo.반관리_선생님필터목록조회 },
    })
  },
  // 해당 반 정보 가져오기
  getLessonClassById(id: number) {
    return maxios.get<DefaultResponse<res.LessonClassDetail>>(`/lesson-classes/${id}`, {
      params: { mp_event_name: mpEventInfo.특정반조회 },
    })
  },
  // 반별 정렬로 학생 출결 가져오기
  getLessonClassesAttendance: (queryString: string) => {
    return maxios.get<Pagination<res.LessonClassesIncludeAttendance[]>>(
      `/lesson-classes/attendance${queryString}`,
      {
        params: { mp_event_name: mpEventInfo.출결관리_반별보기_특정학생출결정보조회 },
      },
    )
  },
  // 반별 정렬로 학생 핸드폰 번호 가져오기 (TODO: 맞나 확인)
  getLessonClassesPhone: () => {
    return maxios.get<Pagination<res.LessonClassesIncludePhone[]>>(`/lesson-classes/phone`, {
      params: { mp_event_name: mpEventInfo.문자전송_반별보기_학생번호조회 },
    })
  },
}

export default lessonClassApi
